import React, { useEffect } from 'react';
import { Button, Form } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { AntButton } from '@/common/ant-components/AntButton';

type VoucherFooterButtonProps = {
  id?: string;
  isFromModal?: boolean;
  onClose?: () => void;
  onCancel?: () => void;
  path: string;
  barcodePrint?: () => void;
  drawer?: any; // Update this to a more specific type if possible
  loading?: boolean;
  isAllowFormSubmit?: boolean;
  setIsCancel?: any;
  handleModalClose: () => void;
};

export const ModalFooterButton: React.FC<VoucherFooterButtonProps> = ({
  isFromModal,
  onClose,
  onCancel,
  path,
  barcodePrint,
  loading,
  setIsCancel,
  handleModalClose = () => {},
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const stockPathList = [
    '/transaction/stock/',
    '/opening/stock/create/',
    '/opening/stock/code/',
  ];
  const isFromStock = stockPathList?.some((pth) => pathname.includes(pth));
  return (
    <div className="tw-flex tw-justify-end tw-py-[8px]">
      <div
        style={{
          display: 'flex',
          float: 'right',
          gap: '10px',
        }}
      >
        {isFromModal ? (
          <>
            <AntButton onClick={onClose} icon={<SaveOutlined />}>
              Save [F10]
            </AntButton>
            <AntButton onClick={onClose} color="red" icon={<CloseOutlined />}>
              Cancel
            </AntButton>
          </>
        ) : (
          <>
            {isFromStock && (
              <AntButton
                // className="submit-button"
                htmlType="submit"
                icon={<SaveOutlined />}
                onClick={() => {
                  setIsCancel && setIsCancel('not-cancel');
                  barcodePrint && barcodePrint();
                }}
                loading={loading}
              >
                Save and Print Barcode
              </AntButton>
            )}
            <AntButton
              // className="submit-button"
              htmlType="submit"
              icon={<SaveOutlined />}
              onClick={() => {
                setIsCancel && setIsCancel('not-cancel');
                !isFromStock && barcodePrint && barcodePrint();
              }}
              loading={loading}
            >
              Save [F10]
            </AntButton>
            <AntButton
              icon={<CloseOutlined />}
              color="red"
              onClick={() => {
                setIsCancel && setIsCancel('cancel');
                handleModalClose && handleModalClose();
                onCancel && onCancel();
                path && navigate(path);
              }}
            >
              Cancel
            </AntButton>
          </>
        )}
      </div>
    </div>
  );
};
